// Import model
import { Fcb2BUnderlaymentOptionCondition } from '../models/Fcb2BUnderlaymentOptionCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { Fcb2BUnderlaymentOptionIndexedFields } from '../models/Fcb2BUnderlaymentOptionIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { Fcb2BUnderlaymentOptionIndexedFieldsSerializer } from './Fcb2BUnderlaymentOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Fcb2BUnderlaymentOptionCondition - handles JSON serialization and deserialization with type validation
 */
export class Fcb2BUnderlaymentOptionConditionSerializer {
  /**
   * Deserializes a JSON string into a Fcb2BUnderlaymentOptionCondition instance
   */
  static deserialize(json: string): Fcb2BUnderlaymentOptionCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Fcb2BUnderlaymentOptionCondition instance
   */
  static fromObject(obj: any): Fcb2BUnderlaymentOptionCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Fcb2BUnderlaymentOptionCondition');
    }


    const instance: Fcb2BUnderlaymentOptionCondition = {
      fieldName: obj['fieldName'] as Fcb2BUnderlaymentOptionIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Fcb2BUnderlaymentOptionCondition instances
   */
  static deserializeArray(json: string): Fcb2BUnderlaymentOptionCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Fcb2BUnderlaymentOptionCondition instance to a JSON string
   */
  static serialize(instance: Fcb2BUnderlaymentOptionCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Fcb2BUnderlaymentOptionCondition instance to a plain object
   */
  static toObject(instance: Fcb2BUnderlaymentOptionCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of Fcb2BUnderlaymentOptionCondition instances to a JSON string
   */
  static serializeArray(instances: Fcb2BUnderlaymentOptionCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
